import React from 'react'
import CardUI from '../../../widgets/layout/CardUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF.js'
import { Link } from 'react-router-dom'
import LoanChequeCreateModalSF from './LoanChequeCreateModalSF.js'
import LoanChequeUpdateModalSF from './LoanChequeUpdateModalSF.js'

const LoanChequePageUI = ({
  context, errorList, loan, onRefreshClick,
  onCreateChequeClick, loanChequeList, onEditChequeClick, onDeleteChequeClick,
  getStatusDisplayValue, loading, onDocsUploadClick, docsUploadMode, onDocsUploadCancel, onDocsUpload,
  onDocDownloadClick, onFileDeleteClick, createMode, updateMode, selectedCheque, onCancelChequeCreate, onCancelChequeUpdate
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_repc'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account && loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='loanCheque'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div className="g_full_width_container">
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_v'>
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <IconButtonUI icon='icon-plus' onClick={onCreateChequeClick} />
                <span className='g_m_left_100 g_large'><b>Loan Cheque</b></span>
              </span>
              <Link to='/su/monitoringIntelligence' className='g_m_left_50 g_m_top_100 g_link'>
                Monitoring Intelligence
              </Link>
            </span>
          }
          right={
            <div className='g_flex_column g_align_end'>
              <Link to='#' className='g_m_left_50' onClick={onDocsUploadClick}>
                Upload Bank Memo
              </Link>

              {
                loanChequeList && loanChequeList.length > 0 && loanChequeList.map((loanCheque, index) => (
                  <div key={index}>
                    {loanCheque.fileUploadList && loanCheque.fileUploadList.length > 0 && loanCheque.fileUploadList.map((file, j) => (
                      <span key={j} className='g_flex_h g_flex_left g_m_top_10'>
                        <Link
                          className='g_m_right_50'
                          onClick={onDocDownloadClick}
                          to='#'
                          data-loan-id={loan.loanId}
                          data-file-name={file}
                        >
                          {file}
                        </Link>
                        <span className='icon icon-trash-o g_m_left_50 g_m_right_50' onClick={onFileDeleteClick}
                          data-file-name={file} />
                      </span>
                    ))}
                  </div>
                ))
              }

            </div>
          }
        />

        {loading ? (
          <div className='g_loading_container'>
            <SpinnerComponentUI />
          </div>
        ) : loanChequeList && loanChequeList.length > 0 ? (
          <LoanChequeUI
            loan={loan}
            context={context}
            loanChequeList={loanChequeList}
            onEditChequeClick={onEditChequeClick}
            onDeleteChequeClick={onDeleteChequeClick}
            getStatusDisplayValue={getStatusDisplayValue}
          />
        ) : (
          <EmptyListUI
            context={context}
            createDisabledMessageLabel='No Cheque Bounce found for this loan'
          />
        )}
        
        {docsUploadMode && (
          <FileUploadModalSF
            context={context}
            titleLabel='Upload Document'
            uploadMode={docsUploadMode}
            onCancelClick={onDocsUploadCancel}
            signedUrlApi={`/api/su/loans/${loan.loanId}/fileUploadSignedUrl`}
            onUpload={onDocsUpload}
          />
        )}
      </div>
    }
    
    {loan && (
      <LoanChequeCreateModalSF
        context={context}
        createMode={createMode}
        loan={loan}
        onCancelClick={onCancelChequeCreate}
        onRefreshClick={onRefreshClick}
      />
    )}
    
    {loan && (
      <LoanChequeUpdateModalSF
        context={context}
        updateMode={updateMode}
        loan={loan}
        selectedCheque={selectedCheque}
        onCancelClick={onCancelChequeUpdate}
        onRefreshClick={onRefreshClick}
      />
    )}
  </SuperUserLoanPageSF>

const LoanChequeUI = ({ context, loan, loanChequeList, onEditChequeClick, onDeleteChequeClick, getStatusDisplayValue }) =>
  <CardUI style={{ maxWidth: '95%', margin: '0 auto' }}>
    <table className='g_full_width g_m_top_20 g_table_fixed'>
      <thead>
        <tr>
          <th className='g_th g_th_col_12'>Cheque Number</th>
          <th className='g_th g_th_col_14'>Amount</th>
          <th className='g_th g_th_col_16'>Bounce Date</th>
          <th className='g_th g_th_col_14'>Bank Name</th>
          <th className='g_th g_th_col_18'>Branch Name</th>
          <th className='g_th g_th_col_22'>Bounce Reason</th>
          <th className='g_th g_th_col_10'>Status</th>
          <th className='g_th g_th_col_12'>Actions</th>
        </tr>
      </thead>
      <tbody>
        {loanChequeList && loanChequeList.map((cheque, i) => (
          <tr key={i}>
            <td className='g_td g_td_nowrap'>{cheque.chequeNumber}</td>
            <td className='g_td'>₹&nbsp;{cheque.amount}</td>
            <td className='g_td'>{cheque.bounceDate}</td>
            <td className='g_td'>{cheque.bankName}</td>
            <td className='g_td'>{cheque.branchName}</td>
            <td className='g_td'>{cheque.bounceReason}</td>
            <td className='g_td'>
              <span className="g_status_tag g_status_open">{getStatusDisplayValue(cheque.closureStatus)}</span>
            </td>
            <td className='g_td'>
              <div className="g_action_buttons">
                <IconButtonUI
                  icon='icon-pencil'
                  onClick={() => onEditChequeClick(cheque)}
                  title="Edit Cheque"
                />
                <IconButtonUI
                  icon='icon-trash-o'
                  onClick={() => onDeleteChequeClick(cheque)}
                  title="Delete Cheque"
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </CardUI>

export default LoanChequePageUI